<template>
  <div style="height: 100%;">
    <!-- toolbar -->
    <v-toolbar
      scroll-off-screen
      :scroll-threshold="30"
      fixed
      class="elevation-2 primary hidden-print-only"
      app
      dense
      dark
    >
      <v-toolbar-title class="text-capitalize">{{pageTitle}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <v-btn flat slot="activator">
          {{user.name}}
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile @click="$store.dispatch('auth/logout')">
            <v-list-tile-avatar>
              <v-icon>mdi-power</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content class="main-content">
      <div class="shadow white round ma-3">
        <router-view/>
      </div>
    </v-content>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  middleware: "auth",
  data: () => ({}),
  computed: {
    pageTitle() {
      return this.$route.name;
    },
    ...mapGetters({
      user: "auth/user"
    })
  }
};
</script>
